import { render, staticRenderFns } from "./MultiWallet.vue?vue&type=template&id=0666a38a&"
import script from "./MultiWallet.vue?vue&type=script&lang=js&"
export * from "./MultiWallet.vue?vue&type=script&lang=js&"
import style0 from "./MultiWallet.vue?vue&type=style&index=0&id=0666a38a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports